<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"700px"'
    :cpntOnFecharDialog='cmsConfigRelatorioFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      <template v-if="cpntTipo === 'produto'">
        Lista de Produtos Comissionados
      </template>
      <template v-else-if="cpntTipo === 'servico'">
        Lista de Serviços Comissionados
      </template>
      <template v-else>
        <span style="color: red">ERROR 500</span>
      </template>
    </template>

    <template slot='conteudo'>
      <App-Comissoes-Config-Form-Tabela ref="produto"
      :cpntTipo="cpntTipo"
      :cpntIdCon="cpntId"
      :cpntEditar="false"
      ></App-Comissoes-Config-Form-Tabela>
    </template>
  </RF-Dialog>
</template>

<style scoped>
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: true
      },
      cpntTipo: {
        required: true
      },

      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Comissoes-Config-Form-Tabela': () => import('@/components/comissoes/config/Comissoes-Config-Form-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: ''
      }
    },
    mounted: function () {
    },
    methods: {
      cmsConfigRelatorioFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar)
      }
    }
  }
</script>
